export const mutationType = {
  GET_LISTS: 'GET_LISTS',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
}
